import { useParams } from "react-router-dom"

export type Maybe<T> = T | null | undefined

export const useRequiredParams = <T extends Record<string, unknown>>() => useParams() as T

/** Membership test that accepts a wide value against a subset list (unlike Array.includes). */
export const isOneOf = <T>(value: T, options: readonly T[]): boolean => options.includes(value)

export type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>
